module.exports = __webpack_public_path__ + "img/91.7d9d977c.jpg";